import { render, staticRenderFns } from "./RecordsDescription.vue?vue&type=template&id=32e58f30&"
import script from "./RecordsDescription.vue?vue&type=script&lang=js&"
export * from "./RecordsDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports